import * as auth from '../../../../app/modules/auth/redux/AuthRedux'

/* eslint-disable jsx-a11y/anchor-is-valid */
import {
  Badge,
  DropdownMenu,
  DropdownToggle,
  ListGroup,
  ListGroupItem,
  Nav,
  NavItem,
  UncontrolledDropdown
} from 'reactstrap';
import React, {FC} from 'react';
import { shallowEqual, useSelector } from 'react-redux'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { NavLink as NavLinkStrap } from 'reactstrap'
import { RootState } from 'setup'
import { UserModel } from 'app/modules/auth/models/UserModel';
import { useDispatch } from 'react-redux'
import { useIntl } from 'react-intl';
import { Link } from 'react-router-dom'
import { ROLE_GENERAL } from 'utils/constants';
import ReactNiceAvatar, { genConfig } from 'react-nice-avatar';

const HeaderUserbox: FC = () => {
  const intl = useIntl();
  const dispatch = useDispatch();

  const user: UserModel = useSelector<RootState>(({auth}) => auth.user, shallowEqual) as UserModel

  const logout = () => {
    dispatch(auth.actions.logout())
  }

  return (
    <>
      <UncontrolledDropdown className='pos ition-relative ml-2 mr-6'>
        <DropdownToggle
          color='link'
          className='p-0 text-left d-flex btn-transition-none align-items-center'
        >
          <div className='d-block p-0 avatar-icon-wrapper'>
            <Badge color='success' className='badge-circle p-top-a'></Badge>
            {/* <Avatar style={{ backgroundColor: 'green' }} size={'large'} className='avatar-user'>
              {(user?.full_name && user?.full_name?.charAt(0)?.toUpperCase())}
            </Avatar> */}

            <ReactNiceAvatar style={{ width: '2.6rem', height: '2.6rem', outline: '3px solid orange', border: '2px solid white' }} {...genConfig(user?.full_name)} />
          </div>
          <div className='pl-2'>
            <div className='font-weight-bold font-size-md'> {user?.full_name ? user.full_name : user.username}</div>
            <span className='text-black-50'> {user.role}</span>
          </div>
          <span className='icon-drop'>
            <FontAwesomeIcon icon={['fas', 'angle-down']} className='opacity-5' />
          </span>
        </DropdownToggle>
        <DropdownMenu right className='dropdown-menu-lg overflow-hidden p-0'>
          <ListGroup flush className='text-left bg-transparent'>
            <ListGroupItem className='rounded-top'>
              <Nav pills className='nav-neutral-primary flex-column'>
                { (user.role !== ROLE_GENERAL.ADMIN || user.role !== ROLE_GENERAL.SUPER_ADMIN) ? (
                  <NavItem>
                    <Link to='/private' className='nav-link nav-link--history'>
                      {intl.formatMessage({id: 'MENU.ACCOUNT_HISTORY'})}
                    </Link>
                  </NavItem>
                ) : null}

                <NavItem>
                  <NavLinkStrap href='#/' onClick={logout}>
                    {intl.formatMessage({id: 'ACCOUNT.LOGOUT'})}
                  </NavLinkStrap>
                </NavItem>
              </Nav>
            </ListGroupItem>
          </ListGroup>
        </DropdownMenu>
      </UncontrolledDropdown>
    </>
  )
}

export default HeaderUserbox
